(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["exworks-bike-fitment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('exworks-bike-fitment')) {
  customElements.define('exworks-bike-fitment', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent);
      this.rules = JSON.parse(this.querySelector('[data-approved]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.make = this.querySelector('[data-make]');
      this.model = this.querySelector('[data-model]');
      this.check = this.querySelector('[data-check]');
      this.checkWrap = this.querySelector('[data-check-wrap]');
      this.checkLabel = this.querySelector('[data-check-label]');
      this.status = this.querySelector('[data-status]');
      this.notes = this.querySelector('[data-notes]');
      this.property = this.querySelector('[data-bike-property]');
      Object.keys(this.catalog).sort((a,b) => a.localeCompare(b,'en')).forEach(make => this.make.add(new Option(make,make)));
      this.make.addEventListener('change', () => this.updateModels());
      this.model.addEventListener('change', () => { this.check.value = ''; this.updateStatus(); });
      this.check.addEventListener('change', () => this.updateStatus());
      this.hidden = false;
    }
    updateModels() {
      const models = this.catalog[this.make.value] || [];
      this.model.replaceChildren(new Option(models.length ? this.strings.select_model : this.strings.select_make_first,''));
      models.slice().sort((a,b) => a.localeCompare(b,'en')).forEach(model => this.model.add(new Option(model,model)));
      this.model.disabled = !models.length;
      this.check.value = '';
      this.updateStatus();
    }
    updateStatus() {
      const make = this.make.value, model = this.model.value;
      const bike = make + ' ' + model;
      const rule = this.rules[this.dataset.product];
      this.status.hidden = !model;
      this.property.disabled = !model;
      this.property.value = model ? bike : '';
      this.checkWrap.hidden = true;
      this.check.disabled = true;
      this.notes.hidden = true;
      this.notes.textContent = '';
      if (!model) { this.status.textContent = ''; delete this.status.dataset.state; return; }
      const listed = (rule.bikes[make] || []).includes(model);
      const excluded = (rule.excluded_makes || []).includes(make) || (rule.excluded_bikes?.[make] || []).includes(model) || (rule.exclusive && !listed);
      const fit = !excluded && (rule.bikes[make] || []).includes(model);
      let state = fit ? 'fits' : 'not-fit';
      let result = state === 'fits' ? 'result_fit' : state === 'not-fit' ? 'result_no' : 'result_unknown';
      if (fit && rule.question) {
        this.checkWrap.hidden = false;
        this.check.disabled = false;
        this.checkLabel.textContent = this.strings[rule.question];
        if (this.check.value === 'yes') { state = 'fits'; result = 'result_fit'; }
        else if (this.check.value === 'no') { state = rule.no_state || 'not-fit'; result = state === 'not-fit' ? 'result_no' : 'result_unknown'; }
        else { state = 'unconfirmed'; result = this.check.value === 'unsure' ? 'result_unknown' : 'result_check'; }
      }
      this.status.dataset.state = state;
      this.status.textContent = this.strings[result].replace('{bike}',bike);
      if (fit && rule.note && (state === 'fits' || rule.no_state === 'unconfirmed')) {
        this.notes.textContent = this.strings[rule.note];
        this.notes.hidden = false;
      }
      const modelNote = rule.model_notes?.[make]?.[model];
      if (state === 'fits' && modelNote) {
        this.notes.textContent = this.strings[modelNote];
        this.notes.hidden = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
